import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  ref: "submitButtonRef",
  id: "kt_modal_bin",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content roundeda" }
const _hoisted_4 = {
  key: 0,
  class: "modal-body scroll-y mx-5 mx-xl-15 my-7"
}
const _hoisted_5 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 1,
  class: "alert alert-success"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "row fv-row" }
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_17 = { class: "fv-plugins-message-container" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-6 flex-column mb-7 fv-row" }
const _hoisted_21 = { class: "fv-plugins-message-container" }
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = {
  key: 0,
  class: "col-6 d-flex flex-column mb-7 fv-row"
}
const _hoisted_24 = { class: "fv-plugins-message-container" }
const _hoisted_25 = { class: "fv-help-block" }
const _hoisted_26 = {
  key: 1,
  class: "col-6 d-flex flex-column mb-7 fv-row"
}
const _hoisted_27 = { class: "fv-plugins-message-container" }
const _hoisted_28 = { class: "fv-help-block" }
const _hoisted_29 = { class: "col-6 d-flex flex-column mb-7 fv-row" }
const _hoisted_30 = { class: "fv-plugins-message-container" }
const _hoisted_31 = { class: "fv-help-block" }
const _hoisted_32 = { class: "col-6 d-flex flex-column mb-7 fv-row" }
const _hoisted_33 = { class: "fv-plugins-message-container" }
const _hoisted_34 = { class: "fv-help-block" }
const _hoisted_35 = {
  key: 2,
  class: "col-6 d-flex flex-column mb-7 fv-row"
}
const _hoisted_36 = { class: "fv-plugins-message-container" }
const _hoisted_37 = { class: "fv-help-block" }
const _hoisted_38 = {
  key: 3,
  class: "col-6 d-flex flex-column mb-7 fv-row"
}
const _hoisted_39 = { class: "fv-plugins-message-container" }
const _hoisted_40 = { class: "fv-help-block" }
const _hoisted_41 = {
  key: 4,
  class: "col-6 d-flex flex-column mb-7 fv-row"
}
const _hoisted_42 = { class: "fv-plugins-message-container" }
const _hoisted_43 = { class: "fv-help-block" }
const _hoisted_44 = {
  key: 5,
  class: "col-6 d-flex flex-column mb-7 fv-row"
}
const _hoisted_45 = { class: "fv-plugins-message-container" }
const _hoisted_46 = { class: "fv-help-block" }
const _hoisted_47 = {
  key: 6,
  class: "col-6 d-flex flex-column mb-7 fv-row"
}
const _hoisted_48 = { class: "fv-plugins-message-container" }
const _hoisted_49 = { class: "fv-help-block" }
const _hoisted_50 = { class: "col-6 d-flex flex-column mb-7 fv-row" }
const _hoisted_51 = { class: "fv-plugins-message-container" }
const _hoisted_52 = { class: "fv-help-block" }
const _hoisted_53 = {
  key: 7,
  class: "col-6 d-flex flex-column mb-7 fv-row"
}
const _hoisted_54 = ["value"]
const _hoisted_55 = { class: "fv-plugins-message-container" }
const _hoisted_56 = { class: "fv-help-block" }
const _hoisted_57 = {
  key: 8,
  class: "col-6 d-flex flex-column mb-7 fv-row"
}
const _hoisted_58 = { class: "fv-plugins-message-container" }
const _hoisted_59 = { class: "fv-help-block" }
const _hoisted_60 = {
  key: 9,
  class: "col-6 d-flex flex-column mb-7 fv-row"
}
const _hoisted_61 = { class: "fv-plugins-message-container" }
const _hoisted_62 = { class: "fv-help-block" }
const _hoisted_63 = {
  key: 10,
  class: "col-6 d-flex flex-column mb-7 fv-row"
}
const _hoisted_64 = { class: "fv-plugins-message-container" }
const _hoisted_65 = { class: "fv-help-block" }
const _hoisted_66 = {
  key: 11,
  class: "col-6 d-flex flex-column mb-7 fv-row"
}
const _hoisted_67 = { class: "fv-plugins-message-container" }
const _hoisted_68 = { class: "fv-help-block" }
const _hoisted_69 = {
  key: 12,
  class: "col-6 d-flex flex-column mb-7 fv-row"
}
const _hoisted_70 = { class: "fv-plugins-message-container" }
const _hoisted_71 = { class: "fv-help-block" }
const _hoisted_72 = {
  key: 13,
  class: "col-6 d-flex flex-column mb-7 fv-row"
}
const _hoisted_73 = { class: "fv-plugins-message-container" }
const _hoisted_74 = { class: "fv-help-block" }
const _hoisted_75 = {
  key: 14,
  class: "col-6 d-flex flex-column mb-7 fv-row"
}
const _hoisted_76 = { class: "fv-plugins-message-container" }
const _hoisted_77 = { class: "fv-help-block" }
const _hoisted_78 = {
  key: 15,
  class: "col-6 d-flex flex-column mb-7 fv-row"
}
const _hoisted_79 = ["value"]
const _hoisted_80 = {
  key: 0,
  value: "add_new"
}
const _hoisted_81 = {
  key: 0,
  class: "row"
}
const _hoisted_82 = { class: "col-9" }
const _hoisted_83 = { class: "col-3" }
const _hoisted_84 = { class: "fv-plugins-message-container" }
const _hoisted_85 = { class: "fv-help-block" }
const _hoisted_86 = {
  key: 16,
  class: "col-6 d-flex flex-column mb-7 fv-row"
}
const _hoisted_87 = ["value"]
const _hoisted_88 = {
  key: 0,
  value: "add_new"
}
const _hoisted_89 = {
  key: 0,
  class: "row"
}
const _hoisted_90 = { class: "col-9" }
const _hoisted_91 = { class: "col-3" }
const _hoisted_92 = { class: "fv-plugins-message-container" }
const _hoisted_93 = { class: "fv-help-block" }
const _hoisted_94 = {
  key: 17,
  class: "col-6 d-flex flex-column mb-7 fv-row"
}
const _hoisted_95 = { class: "fv-plugins-message-container" }
const _hoisted_96 = { class: "fv-help-block" }
const _hoisted_97 = {
  key: 18,
  class: "col-6 d-flex flex-column mb-7 fv-row"
}
const _hoisted_98 = { class: "fv-plugins-message-container" }
const _hoisted_99 = { class: "fv-help-block" }
const _hoisted_100 = { class: "text-center pt-15" }
const _hoisted_101 = {
  type: "reset",
  id: "kt_modal_bin_cancel",
  class: "btn btn-white me-3",
  ref: "cancelRef"
}
const _hoisted_102 = {
  ref: "submitButtonRef",
  type: "submit",
  id: "kt_modal_bin_submit",
  class: "btn btn-primary"
}
const _hoisted_103 = {
  key: 1,
  class: "text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[73] || (_cache[73] = _createStaticVNode("<div class=\"modal-header bg-primary\" data-v-13f92d89><h4 class=\"ms-3 text-white text-uppercase\" data-v-13f92d89> Add Devices to Platform </h4><div class=\"btn btn-sm btn-icon btn-active-color-primary\" data-bs-dismiss=\"modal\" data-v-13f92d89><span class=\"svg-icon svg-icon-1\" data-v-13f92d89><i class=\"bi bi-x-circle-fill light-text fs-3\" style=\"color:white;\" data-v-13f92d89></i></span></div></div>", 1)),
        (_ctx.customer_id > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.addToPlatformResp && _ctx.addToPlatformResp.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("a", {
                      class: "close",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hideAlert())),
                      "aria-label": "Close"
                    }, _cache[30] || (_cache[30] = [
                      _createElementVNode("i", { class: "fas fa-times-circle" }, "close", -1)
                    ])),
                    (_ctx.isObject(_ctx.addToPlatformResp.data.error.message))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addToPlatformResp.data.error, (item, index) => {
                            return (_openBlock(), _createElementBlock("span", { key: index }, [
                              item
                                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(item[0]), 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isObject(_ctx.addToPlatformResp.data.error.message))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.addToPlatformResp.error.message), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.addToPlatformResp && _ctx.addToPlatformResp.success)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("a", {
                      class: "close",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideAlert())),
                      "aria-label": "Close"
                    }, _cache[31] || (_cache[31] = [
                      _createElementVNode("i", { class: "fas fa-times-circle" }, null, -1)
                    ])),
                    (_ctx.addToPlatformResp.success)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                          _createTextVNode(_toDisplayString(_ctx.addToPlatformResp.message) + " ", 1),
                          (_ctx.addToPlatformResp.data.added)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createElementVNode("b", null, "Added IDs (" + _toDisplayString(_ctx.addToPlatformResp.data.added.length) + "):", 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addToPlatformResp.data.added, (device, index) => {
                                  return (_openBlock(), _createElementBlock("span", { key: index }, [
                                    _createTextVNode(_toDisplayString(device.variant_id) + " : : " + _toDisplayString(device.message) + " ", 1),
                                    _cache[32] || (_cache[32] = _createElementVNode("br", null, null, -1))
                                  ]))
                                }), 128)),
                                _cache[36] || (_cache[36] = _createElementVNode("br", null, null, -1)),
                                _createElementVNode("b", null, "Updated IDs (" + _toDisplayString(_ctx.addToPlatformResp.data.updated.length) + "):", 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addToPlatformResp.data.updated, (device, index) => {
                                  return (_openBlock(), _createElementBlock("span", { key: index }, [
                                    _createTextVNode(_toDisplayString(device.variant_id) + " : " + _toDisplayString(device.message) + " ", 1),
                                    _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1))
                                  ]))
                                }), 128)),
                                _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1)),
                                _createElementVNode("b", null, "Skipped IDs (" + _toDisplayString(_ctx.addToPlatformResp.data.skipped.length) + "):", 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addToPlatformResp.data.skipped, (device, index) => {
                                  return (_openBlock(), _createElementBlock("span", { key: index }, [
                                    _createTextVNode(_toDisplayString(device.variant_id) + " : " + _toDisplayString(device.message) + " ", 1),
                                    _cache[34] || (_cache[34] = _createElementVNode("br", null, null, -1))
                                  ]))
                                }), 128)),
                                _cache[38] || (_cache[38] = _createElementVNode("br", null, null, -1)),
                                _createElementVNode("b", null, "Error messages (" + _toDisplayString(_ctx.addToPlatformResp.data.errors.length) + "):", 1),
                                _cache[39] || (_cache[39] = _createElementVNode("br", null, null, -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addToPlatformResp.data.errors, (device, index) => {
                                  return (_openBlock(), _createElementBlock("span", { key: index }, [
                                    _createTextVNode(" Device Id " + _toDisplayString(device.deviceId) + ": ", 1),
                                    (_ctx.isObject(device.message))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addToPlatformResp.message, (device, index) => {
                                            return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(_ctx.item[0]), 1))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true),
                                    (!_ctx.isObject(device.message))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(device.message), 1))
                                      : _createCommentVNode("", true),
                                    _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1))
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_Form, {
                id: "kt_modal_bin_form",
                class: "form",
                onSubmit: _ctx.submit,
                onInvalidSubmit: _ctx.onInvalid,
                "validation-schema": _ctx.validationSchema
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _cache[41] || (_cache[41] = _createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Sensor Type", -1)),
                        _createVNode(_component_Field, {
                          name: "sensor_types_id",
                          "data-control": "select2",
                          "data-hide-search": "true",
                          "data-placeholder": "Select Type",
                          class: "form-select border border-primary form-select-solid",
                          as: "select",
                          modelValue: _ctx.cardData.sensor_types_id,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cardData.sensor_types_id) = $event))
                        }, {
                          default: _withCtx(() => _cache[40] || (_cache[40] = [
                            _createElementVNode("option", { value: "" }, "Select Type", -1),
                            _createElementVNode("option", { value: "1" }, "Bins", -1),
                            _createElementVNode("option", { value: "2" }, "Tracker", -1),
                            _createElementVNode("option", { value: "3" }, "Vision", -1),
                            _createElementVNode("option", { value: "4" }, "Tilt", -1),
                            _createElementVNode("option", { value: "5" }, "V2 (New Server)", -1)
                          ])),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_ErrorMessage, { name: "sensor_types_id" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _cache[42] || (_cache[42] = _createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
                          _createElementVNode("span", { class: "required" }, "Name"),
                          _createElementVNode("i", {
                            class: "fas fa-exclamation-circle ms-2 fs-7",
                            "data-bs-toggle": "tooltip",
                            title: "Specify Bin name"
                          })
                        ], -1)),
                        _createVNode(_component_Field, {
                          type: "text",
                          class: "form-control form-control-solid border border-primary bg-light rounded-2",
                          placeholder: "Name Prefix",
                          name: "name_prefix",
                          modelValue: _ctx.cardData.name_prefix,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.cardData.name_prefix) = $event))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createVNode(_component_ErrorMessage, { name: "name_prefix" })
                          ])
                        ])
                      ]),
                      (_ctx.cardData.sensor_types_id != 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _cache[43] || (_cache[43] = _createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
                              _createElementVNode("span", { class: "required" }, "Address"),
                              _createElementVNode("i", {
                                class: "fas fa-exclamation-circle ms-2 fs-7",
                                "data-bs-toggle": "tooltip",
                                title: "Specify Address of Bin"
                              })
                            ], -1)),
                            _createVNode(_component_Field, {
                              type: "text",
                              class: "form-control form-control-solid border border-primary bg-light rounded-2",
                              placeholder: "Address",
                              name: "address",
                              modelValue: _ctx.cardData.address,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.cardData.address) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, [
                                _createVNode(_component_ErrorMessage, { name: "address" })
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.cardData.sensor_types_id == 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _cache[44] || (_cache[44] = _createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
                              _createElementVNode("span", { class: "" }, "Default Radius"),
                              _createElementVNode("i", {
                                class: "fas fa-exclamation-circle ms-2 fs-7",
                                "data-bs-toggle": "tooltip",
                                title: "Specify default radius"
                              })
                            ], -1)),
                            _createVNode(_component_Field, {
                              type: "number",
                              class: "form-control form-control-solid border border-primary bg-light rounded-2",
                              placeholder: "ex. 500",
                              name: "default_radius",
                              modelValue: _ctx.cardData.default_radius,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.cardData.default_radius) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("div", _hoisted_28, [
                                _createVNode(_component_ErrorMessage, { name: "default_radius" })
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_29, [
                        _cache[45] || (_cache[45] = _createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
                          _createElementVNode("span", { class: "required" }, "Latitude"),
                          _createElementVNode("i", {
                            class: "fas fa-exclamation-circle ms-2 fs-7",
                            "data-bs-toggle": "tooltip",
                            title: "Specify Bin's Latitude"
                          })
                        ], -1)),
                        _createVNode(_component_Field, {
                          type: "text",
                          class: "form-control form-control-solid border border-primary bg-light rounded-2",
                          placeholder: "Latitude",
                          name: "lat",
                          modelValue: _ctx.cardData.lat,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.cardData.lat) = $event))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createVNode(_component_ErrorMessage, { name: "lat" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _cache[46] || (_cache[46] = _createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
                          _createElementVNode("span", { class: "required" }, "Longitude"),
                          _createElementVNode("i", {
                            class: "fas fa-exclamation-circle ms-2 fs-7",
                            "data-bs-toggle": "tooltip",
                            title: "Specify Bin's Longitude"
                          })
                        ], -1)),
                        _createVNode(_component_Field, {
                          type: "text",
                          class: "form-control form-control-solid border border-primary bg-light rounded-2",
                          placeholder: "Longitude",
                          name: "lng",
                          modelValue: _ctx.cardData.lng,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.cardData.lng) = $event))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            _createVNode(_component_ErrorMessage, { name: "lng" })
                          ])
                        ])
                      ]),
                      (
                    _ctx.cardData.sensor_types_id != 5 &&
                    _ctx.cardData.sensor_types_id != 4 &&
                    _ctx.cardData.sensor_types_id != 3
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                            _cache[47] || (_cache[47] = _createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2 required" }, [
                              _createElementVNode("span", null, "Pickup Threshold "),
                              _createElementVNode("i", {
                                class: "fas fa-exclamation-circle ms-2 fs-7",
                                "data-bs-toggle": "tooltip",
                                title: "Specify Bin's Pickup Threshold"
                              })
                            ], -1)),
                            _createVNode(_component_Field, {
                              type: "number",
                              class: "form-control form-control-solid border border-primary bg-light rounded-2",
                              placeholder: "Threshold",
                              name: "pickup_threshold",
                              modelValue: _ctx.cardData.pickup_threshold,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.cardData.pickup_threshold) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, [
                                _createVNode(_component_ErrorMessage, { name: "pickup_threshold" })
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (
                    _ctx.checkKPI &&
                    (_ctx.cardData.sensor_types_id == 1 ||
                      _ctx.cardData.sensor_types_id == 5)
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _cache[48] || (_cache[48] = _createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2 required" }, [
                              _createElementVNode("span", { class: "" }, "Weight Per Commodity")
                            ], -1)),
                            _createVNode(_component_Field, {
                              type: "text",
                              class: "form-control form-control-solid border border-primary bg-light rounded-2",
                              placeholder: "Weight Per Commodity",
                              name: "weight_per_commodity",
                              modelValue: _ctx.cardData.weight_per_commodity,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.cardData.weight_per_commodity) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("div", _hoisted_40, [
                                _createVNode(_component_ErrorMessage, { name: "weight_per_commodity" })
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (
                    _ctx.checkKPI &&
                    (_ctx.cardData.sensor_types_id == 1 ||
                      _ctx.cardData.sensor_types_id == 5)
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            _cache[49] || (_cache[49] = _createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
                              _createElementVNode("span", null, "Bin Capacity For KPI")
                            ], -1)),
                            _createVNode(_component_Field, {
                              type: "text",
                              class: "form-control form-control-solid border border-primary bg-light rounded-2",
                              placeholder: "Bin Capacity",
                              name: "bin_capacity",
                              modelValue: _ctx.cardData.bin_capacity,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.cardData.bin_capacity) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_42, [
                              _createElementVNode("div", _hoisted_43, [
                                _createVNode(_component_ErrorMessage, { name: "bin_capacity" })
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.cardData.sensor_types_id == 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                            _cache[51] || (_cache[51] = _createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "GPS Validity", -1)),
                            _createVNode(_component_Field, {
                              name: "gps_validity",
                              "data-control": "select2",
                              "data-hide-search": "true",
                              "data-placeholder": "Select Type",
                              class: "form-select border border-primary form-select-solid",
                              as: "select",
                              modelValue: _ctx.cardData.gps_validity,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.cardData.gps_validity) = $event))
                            }, {
                              default: _withCtx(() => _cache[50] || (_cache[50] = [
                                _createElementVNode("option", { value: "" }, "Select Type", -1),
                                _createElementVNode("option", { value: "1" }, "Enable", -1),
                                _createElementVNode("option", { value: "0" }, "Disable", -1)
                              ])),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("div", _hoisted_46, [
                                _createVNode(_component_ErrorMessage, { name: "sensor_types_id" })
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (
                    _ctx.cardData.sensor_types_id == 1 ||
                    _ctx.cardData.sensor_types_id == 5
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                            _cache[52] || (_cache[52] = _createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2 required" }, [
                              _createElementVNode("span", { class: "" }, "Bin Height"),
                              _createElementVNode("i", {
                                class: "fas fa-exclamation-circle ms-2 fs-7",
                                "data-bs-toggle": "tooltip",
                                title: "Specify Bin Height"
                              })
                            ], -1)),
                            _createVNode(_component_Field, {
                              type: "number",
                              class: "form-control form-control-solid border border-primary bg-light rounded-2",
                              placeholder: "ex. 100",
                              name: "bin_height",
                              modelValue: _ctx.cardData.bin_height,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.cardData.bin_height) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_48, [
                              _createElementVNode("div", _hoisted_49, [
                                _createVNode(_component_ErrorMessage, { name: "bin_height" })
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_50, [
                        _cache[53] || (_cache[53] = _createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2 required" }, [
                          _createElementVNode("span", null, "Battery"),
                          _createElementVNode("i", {
                            class: "fas fa-exclamation-circle ms-2 fs-7",
                            "data-bs-toggle": "tooltip",
                            title: "Specify Battery"
                          })
                        ], -1)),
                        _createVNode(_component_Field, {
                          type: "number",
                          class: "form-control form-control-solid border border-primary bg-light rounded-2",
                          placeholder: "ex. 100",
                          name: "battery",
                          modelValue: _ctx.cardData.battery,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.cardData.battery) = $event))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("div", _hoisted_52, [
                            _createVNode(_component_ErrorMessage, { name: "battery" })
                          ])
                        ])
                      ]),
                      (
                    _ctx.cardData.sensor_types_id == 1 ||
                    _ctx.cardData.sensor_types_id == 5 ||
                    _ctx.cardData.sensor_types_id == 3
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                            _cache[55] || (_cache[55] = _createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2 required" }, [
                              _createElementVNode("span", null, " Waste Type "),
                              _createElementVNode("i", {
                                class: "fas fa-exclamation-circle ms-2 fs-7",
                                "data-bs-toggle": "tooltip",
                                title: "Specify Waste Type of Bin"
                              })
                            ], -1)),
                            _createVNode(_component_Field, {
                              name: "waste_type_id",
                              "data-control": "select2",
                              "data-hide-search": "true",
                              "data-placeholder": "Select Type",
                              class: "form-select border border-primary form-select-solid",
                              as: "select",
                              modelValue: _ctx.cardData.waste_type_id,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.cardData.waste_type_id) = $event))
                            }, {
                              default: _withCtx(() => [
                                _cache[54] || (_cache[54] = _createElementVNode("option", { value: "" }, "Select Type", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.wasteType, (role, i) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: i,
                                    value: role.id
                                  }, _toDisplayString(role.name), 9, _hoisted_54))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_55, [
                              _createElementVNode("div", _hoisted_56, [
                                _createVNode(_component_ErrorMessage, { name: "waste_type_id" })
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (
                    _ctx.cardData.sensor_types_id == 1 ||
                    _ctx.cardData.sensor_types_id == 5 ||
                    _ctx.cardData.sensor_types_id == 3 ||
                    _ctx.cardData.sensor_types_id == 2
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                            _cache[56] || (_cache[56] = _createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2 required" }, [
                              _createElementVNode("span", { class: "" }, "Routing Volume"),
                              _createElementVNode("i", {
                                class: "fas fa-exclamation-circle ms-2 fs-7",
                                "data-bs-toggle": "tooltip",
                                title: "Enter routing_volume value"
                              })
                            ], -1)),
                            _createVNode(_component_Field, {
                              type: "number",
                              class: "form-control form-control-solid border border-primary bg-light rounded-2",
                              placeholder: "ex. 100",
                              name: "routing_volume",
                              modelValue: _ctx.cardData.routing_volume,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.cardData.routing_volume) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_58, [
                              _createElementVNode("div", _hoisted_59, [
                                _createVNode(_component_ErrorMessage, { name: "routing_volume" })
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (
                    _ctx.cardData.sensor_types_id == 1 ||
                    _ctx.cardData.sensor_types_id == 5 ||
                    _ctx.cardData.sensor_types_id == 2
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                            _cache[57] || (_cache[57] = _createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2 required" }, [
                              _createElementVNode("span", null, "Min Measurable Distance"),
                              _createElementVNode("i", {
                                class: "fas fa-exclamation-circle ms-2 fs-7",
                                "data-bs-toggle": "tooltip",
                                title: "minimum measure value 0 - 30"
                              })
                            ], -1)),
                            _createVNode(_component_Field, {
                              type: "number",
                              class: "form-control form-control-solid border border-primary bg-light rounded-2",
                              placeholder: "ex. 100",
                              name: "min_measurable_distance",
                              modelValue: _ctx.cardData.min_measurable_distance,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.cardData.min_measurable_distance) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_61, [
                              _createElementVNode("div", _hoisted_62, [
                                _createVNode(_component_ErrorMessage, { name: "min_measurable_distance" })
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (
                    _ctx.cardData.sensor_types_id == 1 ||
                    _ctx.cardData.sensor_types_id == 5 ||
                    _ctx.cardData.sensor_types_id == 2
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                            _cache[58] || (_cache[58] = _createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2 required" }, [
                              _createElementVNode("span", { class: "" }, "Maximum Measurable Distance"),
                              _createElementVNode("i", {
                                class: "fas fa-exclamation-circle ms-2 fs-7",
                                "data-bs-toggle": "tooltip",
                                title: "maximum measure value 30 - 1000"
                              })
                            ], -1)),
                            _createVNode(_component_Field, {
                              type: "number",
                              class: "form-control form-control-solid border border-primary bg-light rounded-2",
                              placeholder: "ex. 100",
                              name: "max_measurable_distance",
                              modelValue: _ctx.cardData.max_measurable_distance,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.cardData.max_measurable_distance) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_64, [
                              _createElementVNode("div", _hoisted_65, [
                                _createVNode(_component_ErrorMessage, { name: "max_measurable_distance" })
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (
                    _ctx.checkKPI &&
                    (_ctx.cardData.sensor_types_id == 1 ||
                      _ctx.cardData.sensor_types_id == 5)
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                            _cache[59] || (_cache[59] = _createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2 required" }, [
                              _createElementVNode("span", null, "Bin Type")
                            ], -1)),
                            _createVNode(_component_Field, {
                              type: "text",
                              class: "form-control form-control-solid border border-primary bg-light rounded-2",
                              placeholder: "Bin Type",
                              name: "bin_type",
                              modelValue: _ctx.cardData.bin_type,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.cardData.bin_type) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_67, [
                              _createElementVNode("div", _hoisted_68, [
                                _createVNode(_component_ErrorMessage, { name: "bin_type" })
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (
                    _ctx.checkKPI &&
                    (_ctx.cardData.sensor_types_id == 1 ||
                      _ctx.cardData.sensor_types_id == 5)
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                            _cache[60] || (_cache[60] = _createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2 required" }, [
                              _createElementVNode("span", { class: "" }, "Pickup Percentage Threshold"),
                              _createElementVNode("i", {
                                class: "fas fa-exclamation-circle ms-2 fs-7",
                                "data-bs-toggle": "tooltip",
                                title: "Enter the pickup percentage threshold in number"
                              })
                            ], -1)),
                            _createVNode(_component_Field, {
                              type: "number",
                              class: "form-control form-control-solid border border-primary bg-light rounded-2",
                              placeholder: "ex. 100",
                              name: "perc_threshold",
                              modelValue: _ctx.cardData.perc_threshold,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.cardData.perc_threshold) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_70, [
                              _createElementVNode("div", _hoisted_71, [
                                _createVNode(_component_ErrorMessage, { name: "perc_threshold" })
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (
                    _ctx.checkKPI &&
                    (_ctx.cardData.sensor_types_id == 1 ||
                      _ctx.cardData.sensor_types_id == 5)
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                            _cache[61] || (_cache[61] = _createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2 required" }, [
                              _createElementVNode("span", { class: "" }, "Pickup Absolute Threshold"),
                              _createElementVNode("i", {
                                class: "fas fa-exclamation-circle ms-2 fs-7",
                                "data-bs-toggle": "tooltip",
                                title: "Enter the pickup absolute threshold in number"
                              })
                            ], -1)),
                            _createVNode(_component_Field, {
                              type: "number",
                              class: "form-control form-control-solid border border-primary bg-light rounded-2",
                              placeholder: "ex. 100",
                              name: "abs_threshold",
                              modelValue: _ctx.cardData.abs_threshold,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.cardData.abs_threshold) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_73, [
                              _createElementVNode("div", _hoisted_74, [
                                _createVNode(_component_ErrorMessage, { name: "abs_threshold" })
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (
                    _ctx.checkKPI &&
                    (_ctx.cardData.sensor_types_id == 1 ||
                      _ctx.cardData.sensor_types_id == 5)
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                            _cache[62] || (_cache[62] = _createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2 required" }, [
                              _createElementVNode("span", { class: "" }, "Pickup minmum fill level Threshold"),
                              _createElementVNode("i", {
                                class: "fas fa-exclamation-circle ms-2 fs-7",
                                "data-bs-toggle": "tooltip",
                                title: "Enter the pickup absolute threshold in number"
                              })
                            ], -1)),
                            _createVNode(_component_Field, {
                              type: "number",
                              class: "form-control form-control-solid border border-primary bg-light rounded-2",
                              placeholder: "ex. 100",
                              name: "min_fill_level",
                              modelValue: _ctx.cardData.min_fill_level,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.cardData.min_fill_level) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_76, [
                              _createElementVNode("div", _hoisted_77, [
                                _createVNode(_component_ErrorMessage, { name: "min_fill_level" })
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (
                    _ctx.checkKPI &&
                    (_ctx.cardData.sensor_types_id == 1 ||
                      _ctx.cardData.sensor_types_id == 5)
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                            _cache[64] || (_cache[64] = _createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2 required" }, [
                              _createElementVNode("span", null, "Select Group")
                            ], -1)),
                            _createElementVNode("div", null, [
                              _createVNode(_component_Field, {
                                name: "group_id",
                                as: "select",
                                modelValue: _ctx.cardData.group_id,
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.cardData.group_id) = $event)),
                                onChange: _ctx.groupHandleChange,
                                class: "form-select form-control form-control-solid border border-primary bg-light rounded-2"
                              }, {
                                default: _withCtx(() => [
                                  _cache[63] || (_cache[63] = _createElementVNode("option", { value: "" }, "Select Group", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupList, (option, index) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: index,
                                      value: option.group_id
                                    }, _toDisplayString(option.group_name), 9, _hoisted_79))
                                  }), 128)),
                                  (!_ctx.cardData.group_id)
                                    ? (_openBlock(), _createElementBlock("option", _hoisted_80, " Add New Option... "))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"]),
                              (_ctx.addingGroupOption)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                    _createElementVNode("div", _hoisted_82, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "form-control form-control-solid border border-primary bg-light rounded-2 mt-2",
                                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.newGroup) = $event)),
                                        placeholder: "New Option"
                                      }, null, 512), [
                                        [_vModelText, _ctx.newGroup]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_83, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.addNewGroup())),
                                        class: "btn add-new-button mt-2"
                                      }, " Go ")
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_84, [
                                _createElementVNode("div", _hoisted_85, [
                                  _createVNode(_component_ErrorMessage, { name: "group_id" })
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (
                    _ctx.checkKPI &&
                    _ctx.cardData.group_id &&
                    _ctx.cardData.group_id != 'add_new' &&
                    (_ctx.cardData.sensor_types_id == 1 ||
                      _ctx.cardData.sensor_types_id == 5) &&
                    _ctx.cardData.lat &&
                    _ctx.cardData.lng
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                            _cache[66] || (_cache[66] = _createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2 required" }, [
                              _createElementVNode("span", null, "Select Address")
                            ], -1)),
                            _createElementVNode("div", null, [
                              _createVNode(_component_Field, {
                                name: "address_id",
                                as: "select",
                                modelValue: _ctx.cardData.address_id,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.cardData.address_id) = $event)),
                                onChange: _ctx.handleChange,
                                class: "form-select"
                              }, {
                                default: _withCtx(() => [
                                  _cache[65] || (_cache[65] = _createElementVNode("option", { value: "" }, "Select Address", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addressList, (option, index) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: index,
                                      value: option.address_id
                                    }, _toDisplayString(option.address_name), 9, _hoisted_87))
                                  }), 128)),
                                  (!_ctx.cardData.address_id)
                                    ? (_openBlock(), _createElementBlock("option", _hoisted_88, " Add New Option... "))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"]),
                              (_ctx.addingOption)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                    _createElementVNode("div", _hoisted_90, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "form-control mt-2",
                                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.newOption) = $event)),
                                        placeholder: "New Option"
                                      }, null, 512), [
                                        [_vModelText, _ctx.newOption]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_91, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.addNewAddress())),
                                        class: "btn add-new-button mt-2"
                                      }, " Go ")
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_92, [
                                _createElementVNode("div", _hoisted_93, [
                                  _createVNode(_component_ErrorMessage, { name: "address_id" })
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.cardData.sensor_types_id == 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                            _cache[68] || (_cache[68] = _createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Fence Status", -1)),
                            _createVNode(_component_Field, {
                              name: "fence_status",
                              "data-control": "select2",
                              "data-hide-search": "true",
                              "data-placeholder": "Select Type",
                              class: "form-select border border-primary form-select-solid",
                              as: "select",
                              modelValue: _ctx.cardData.fence_status,
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.cardData.fence_status) = $event))
                            }, {
                              default: _withCtx(() => _cache[67] || (_cache[67] = [
                                _createElementVNode("option", { value: "" }, "Select Type", -1),
                                _createElementVNode("option", { value: "1" }, "Enable", -1),
                                _createElementVNode("option", { value: "0" }, "Disable", -1)
                              ])),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_95, [
                              _createElementVNode("div", _hoisted_96, [
                                _createVNode(_component_ErrorMessage, { name: "fence_status" })
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.cardData.sensor_types_id == 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                            _cache[70] || (_cache[70] = _createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Motion Status", -1)),
                            _createVNode(_component_Field, {
                              name: "motion_status",
                              "data-control": "select2",
                              "data-hide-search": "true",
                              "data-placeholder": "Select Type",
                              class: "form-select border border-primary form-select-solid",
                              as: "select",
                              modelValue: _ctx.cardData.motion_status,
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.cardData.motion_status) = $event))
                            }, {
                              default: _withCtx(() => _cache[69] || (_cache[69] = [
                                _createElementVNode("option", { value: "" }, "Select Type", -1),
                                _createElementVNode("option", { value: "1" }, "Enable", -1),
                                _createElementVNode("option", { value: "0" }, "Disable", -1)
                              ])),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_98, [
                              _createElementVNode("div", _hoisted_99, [
                                _createVNode(_component_ErrorMessage, { name: "motion_status" })
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_100, [
                    _createElementVNode("button", _hoisted_101, " Clear ", 512),
                    _createElementVNode("button", _hoisted_102, _cache[71] || (_cache[71] = [
                      _createElementVNode("span", { class: "indicator-label" }, " Submit", -1),
                      _createElementVNode("span", { class: "indicator-progress" }, [
                        _createTextVNode(" Please wait... "),
                        _createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
                      ], -1)
                    ]), 512)
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit", "onInvalidSubmit", "validation-schema"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_103, _cache[72] || (_cache[72] = [
              _createElementVNode("h5", { class: "text-danger p-10" }, "Please Select the Company first", -1)
            ])))
      ])
    ])
  ], 512))
}